const messages = {
    buttons: {
        productBrochures: "Atrasti",
    },
    index: {
        title: "PRODUKTO INFORMACIJA",
        description: "Atsisiųskite čia naujausius mūsų Bridgestone ir Firestone padangų brošiūras ir skrajutes.",
        categories: {
            productBrochures: {
                title: "Produktų brošiūros",
                description: "Bridgestone ir Firestone padangų serijų brošiūros",
            },
            bDrive: {
              title: "Produktų nuotraukos",
              description: "Naujausias nuotraukas galite atsisiųsti iš mūsų B-DRIVE portalo.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

